import { USER_SERVER } from "./constants";
import request from "./request";

export interface LoginBaseProps {
    account: string; // 账号
    password?: string; // 密码（验证码方式登录不需要密码）
    client_type: string; // game_client
    verification_code?: string; // 验证码登录
    mobile_id: string; // 必传：用户手机唯一标识
}

export interface LoginProps extends LoginBaseProps {
    login_type: string; // pwd/code(密码登录或者验证码登录，不传默认密码登录)
}

export interface RegisterProps extends LoginBaseProps {
    push_tag: boolean; //   true:同意/false：不同意
}
export interface LoginPropsV2 extends LoginProps {
    force_flag: number; // 0：默认情况 不是用户选择强制登录  2：OBSBOT账号已注册并且处于账号注销保留期选择继续登录
}

export interface SendCodeProps {
    account: string; // 账号
    /**
     * 验证码类型：
     * user_cancel（账号注销）、register(注册) forget_pwd(忘记密码) modify_pwd（修改密码）
     * change_account（切换账号） login(登录) activate_code（激活码）safe_check（出于安全考虑校验老账号）
     * crowdfunding （众筹信息收集校验验证码）
     **/
    msg_type: string;
    client_type: string; // game_client
    mobile_id: string; // 必传：用户手机唯一标识
    lan: string; // 语言：cn
}

export interface LoginProcessResult {
    data: LoginData;
    code: string;
    msg: string;
}

export interface LoginData {
    token: string;
    userSig: string;
    sdkAppId: number;
    image: boolean;
    user_id: string;
    refresh_token: string;
}

export interface VerifyCodeValProps {
    account: string;
    msg_type: string;
    client_type: string;
    verification_code: string;
    force_flag: number;
    mobile_id: string;
}

export const registerV1 = async (props: RegisterProps): Promise<LoginProcessResult> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/register",
        method: "post",
        data: props,
    });
};

// 视频开黑定制版登录
export const loginCustom = async (props: LoginPropsV2): Promise<LoginProcessResult> => {
    return request({
        url: USER_SERVER + "/ums/v2/users/logon",
        method: "post",
        data: props,
    });
};

// 发送验证码
export const sendVerifyCode = async (props: SendCodeProps): Promise<any> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/verification-codes",
        method: "post",
        data: props,
    });
};

// 校验验证码
export const verifyCodeVal = async (data: VerifyCodeValProps): Promise<{ valid: boolean }> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/verification-codes/validation",
        method: "post",
        data,
    });
};

interface forgotProps {
    account: string;
    verification_code: string;
    password: string;
    mobile_id: string;
    client_type: string;
}

// 忘记密码
export const forgotPwd = async (data: forgotProps): Promise<{ user_id: string }> => {
    return request({
        url: USER_SERVER + "/ums/v1/users/forget-pwd",
        method: "put",
        data,
    });
};

// 退出登录
export const logout = async (): Promise<any> => {
    return request({
        url: USER_SERVER + "/ums/v1/game/logout",
        method: "post",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};
